import React, { FC, Fragment, useContext } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { LabOrderContext } from 'pages/order-flow/lab-order/lab-order-context';
import ConstructionSummaryProperties from './construction-summary-properties.component';
import ConstructionSummaryActions from './construction-summary-actions.component';
import ConstructionSummaryMaterials from './construction-summary-materials.component';
import { formatTeethList } from 'utils/teeth';

const ConstructionsSummary: FC = () => {
    const { t: translate } = useTranslation(['orders', 'common', 'construction-props']);

    const { order } = useContext(LabOrderContext);

    return (
        <Fragment>
            {order.constructions.map((construction, index) => (
                <Box key={index} mb={2}>
                    <Paper variant="outlined">
                        <Box p={2}>
                            <Box mb={2}>
                                <Typography variant="h4">
                                    {translate('orders:TOOTH')} {formatTeethList(Array.from(construction.teethNumbers))}{' '}
                                    {translate(`construction-props:${construction.properties?.material || ''}`)}
                                </Typography>
                            </Box>

                            {construction.warranty && construction.warrantyType !== 'NONE' ? (
                                <Box display="flex" mb={2}>
                                    <Box mr={0.5}>
                                        <Typography variant="subtitle2">{translate('orders:WARRANTY')}:</Typography>
                                    </Box>
                                    <Box>{translate(`orders:${construction.warrantyType}`)}</Box>
                                </Box>
                            ) : undefined}

                            <Box mb={2}>
                                <ConstructionSummaryProperties properties={construction.properties} />
                            </Box>

                            {construction.actions.length > 0 ? (
                                <Box mb={3}>
                                    <ConstructionSummaryActions
                                        actions={construction.actions}
                                        isWarranty={construction.warranty}
                                    />
                                </Box>
                            ) : undefined}

                            {construction.materials.length > 0 ? (
                                <Box>
                                    <ConstructionSummaryMaterials materials={construction.materials} />
                                </Box>
                            ) : undefined}
                        </Box>
                    </Paper>
                </Box>
            ))}
        </Fragment>
    );
};

export default ConstructionsSummary;
